<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { computed, onBeforeUnmount, watch } from 'vue';
import { RouterView, useRoute } from 'vue-router';

import AppShell from '@/components/layout/AppShell.vue';
import ConfirmHost from '@/components/ui/ConfirmHost.vue';
import ToastHost from '@/components/ui/ToastHost.vue';
import { dashboardSocket } from '@/lib/ws';
import { useAuthStore } from '@/stores/auth';

/**
 * Root component.
 *
 * It owns exactly one piece of behaviour: the realtime socket follows the
 * session. Opening it here rather than per screen means the three agent signals
 * and the project status keep updating while the user is on any page, and that a
 * logout tears the socket down instead of leaving an authenticated connection
 * open behind a login screen.
 */

const auth = useAuthStore();
const route = useRoute();
const { isAuthenticated } = storeToRefs(auth);

const showShell = computed(() => isAuthenticated.value && route.meta.public !== true);

watch(
  isAuthenticated,
  (authenticated) => {
    if (authenticated) void dashboardSocket.connect();
    else dashboardSocket.disconnect();
  },
  { immediate: true },
);

onBeforeUnmount(() => dashboardSocket.disconnect());
</script>

<template>
  <AppShell v-if="showShell">
    <RouterView />
  </AppShell>
  <RouterView v-else />

  <ToastHost />
  <ConfirmHost />
</template>
